export function careerValidation(field) {

    const errors = {
        headerSection: {
            section: {},
            pageTitle: ""
        },

        brandStorySection: {
            section: {},
            pageTitle: ""
        },
        jobOpeningsSection: {
            section: [],
            pageTitle: "",
            link: ""
        },
        customerExperienceSection: {
            section: [],
            pageTitle: ""
        },
        faq: {
            section: [],
        },
        testimonialsSection: {
            members: [],
            pageTitle: ""
        },
        metaProperties: {
            title: "",
            description: ""
        }
    };
    if (!field?.metaProperties?.title?.trim()) {
        errors.metaProperties.title = "Meta Title is required";
    }

    if (!field?.metaProperties?.description?.trim()) {
        errors.metaProperties.description = "Meta Description is required";
    }
    // Example validation rules:
    if (field?.headerSection?.status) {
        if (!field?.headerSection?.pageTitle?.trim()) {
            errors.headerSection.pageTitle = "Title is required";
        }

        if (!field?.headerSection?.section?.description?.trim()) {
            errors.headerSection.section.description = "Description is required";
        }

        if (!field?.headerSection?.section?.cta) {
            errors.headerSection.section.cta = "CTA is required";
        }
        if (!field?.headerSection?.section?.url) {
            errors.headerSection.section.url = "CTA Link is required";
        }

        if (field?.headerSection?.section?.url && !validURL(field?.headerSection?.section?.url)) {
            errors.headerSection.section.url = "Invalid link: must start with http:// or https://";
        }
    }

    // Brand story section
    if (field?.brandStorySection?.status) {

        if (!field?.brandStorySection?.pageTitle?.trim()) {
            errors.brandStorySection.pageTitle = "Title is required";
        } else if (field?.brandStorySection?.pageTitle?.length > 60) {
            errors.brandStorySection.pageTitle = "Character limit exceeded.";
        }

        if (!field?.brandStorySection?.section?.description?.trim()) {
            errors.brandStorySection.section.description = "Description is required";
        } else if (field?.brandStorySection?.section?.description?.length > 950) {
            errors.brandStorySection.section.description = "Character limit exceeded.";
        }

        // if (!field?.brandStorySection?.section?.imageUrl) {
        //     errors.brandStorySection.section.imageUrl = "Image is required";
        // }

        if (!field?.brandStorySection?.section?.image || !field.brandStorySection.section.image.url?.trim()) {
            errors.brandStorySection.section.image = {
                ...(errors.brandStorySection.section.image || {}), // Ensure image object exists
                url: "Image  is required",
            };
        }
        if (!field?.customerExperienceSection?.status) {
            if (!field?.customerExperienceSection?.pageTitle?.trim()) {
                errors.customerExperienceSection.pageTitle = "Title is required";
            }




            if (field?.customerExperienceSection?.section?.length > 0) {
                field.customerExperienceSection.section.forEach((banner, index) => {
                    const bannerErrors = {};

                    // Check for title
                    if (!banner.title?.trim()) {
                        bannerErrors.title = "Title is required";
                    } else if (banner.title.length > 60) {
                        bannerErrors.title = "Character limit exceeded.";
                    }

                    // Check for description
                    if (!banner.description?.trim()) {
                        bannerErrors.description = "Description is required";
                    } else if (banner.description.length > 550) {
                        bannerErrors.description = "Character limit exceeded.";
                    }


                    // Check for imageUrl
                    if (!banner.image || !banner.image.url?.trim()) {
                        bannerErrors.image = {
                            ...(bannerErrors.image || {}), // Ensure image object exists
                            url: "Image  is required",
                        };
                    }
                    // Add banner-level errors to the customerExperienceSection errors array
                    if (Object.keys(bannerErrors).length > 0) {
                        errors.customerExperienceSection.section[index] = bannerErrors;
                    }
                });
            }
        }


    }

    if (field?.testimonialsSection?.status) {
        if (!field?.testimonialsSection?.pageTitle?.trim()) {
            errors.testimonialsSection.pageTitle = "Title is required";
        }

        if (field?.testimonialsSection?.members?.length > 0) {
            field.testimonialsSection.members.forEach((banner, index) => {
                const bannerErrors = {};

                // Check for title
                if (!banner.name?.trim()) {
                    bannerErrors.name = "Name is required";
                }
                // Check for title
                if (!banner.role?.trim()) {
                    bannerErrors.role = "Role is required";
                }

                // Check for description
                if (!banner.description?.trim()) {
                    bannerErrors.description = "Description is required";
                }

                // Check for imageUrl
                // if (!banner.imageUrl) {
                //     bannerErrors.imageUrl = "Image is required";
                // }
                if (!banner.image || !banner.image.url?.trim()) {
                    bannerErrors.image = {
                        ...(bannerErrors.image || {}), // Ensure image object exists
                        url: "Image  is required",
                    };
                }
                // Add banner-level errors to the testimonialsSection errors array
                if (Object.keys(bannerErrors).length > 0) {
                    errors.testimonialsSection.members[index] = bannerErrors;
                }
            });



            // **Validate displaySettings - At least one should be true**
            if (!Object.values(field?.displaySettings || {}).includes(true)) {
                errors.displaySettings = "At least one display option must be selected.";
            }

        }
    }

    if (field?.jobOpeningsSection?.status) {
        if (!field?.jobOpeningsSection?.pageTitle?.trim()) {
            errors.jobOpeningsSection.pageTitle = "Title is required";
        }
        if (!field?.jobOpeningsSection?.link) {
            errors.jobOpeningsSection.link = "Link is required";
        }
        if (field?.jobOpeningsSection?.link && !validURL(field?.jobOpeningsSection?.link)) {
            errors.jobOpeningsSection.link = "Invalid link: must start with http:// or https://";
        }
        // if (field?.jobOpeningsSection?.link && !validURL(field?.jobOpeningsSection?.link)) {
        //     errors.jobOpeningsSection.link = "Invalid link: must start with http:// or https://";
        // }
        if (field?.jobOpeningsSection?.section?.length > 0) {
            field.jobOpeningsSection.section.forEach((banner, index) => {
                const bannerErrors = {};

                // Check for title
                if (!banner.title?.trim()) {
                    bannerErrors.title = "Title is required";
                } else if (banner.title.length > 60) {
                    bannerErrors.title = "Character limit exceeded.";
                }
                // Check for description
                if (!banner.description?.trim()) {
                    bannerErrors.description = "Description is required";
                } else if (banner.description.length > 450) {
                    bannerErrors.description = "Character limit exceeded.";
                }
                // Check for imageUrl
                // if (!banner.imageUrl) {
                //     bannerErrors.imageUrl = "Image is required";
                // }
                if (!banner.image || !banner.image.url?.trim()) {
                    bannerErrors.image = {
                        ...(bannerErrors.image || {}), // Ensure image object exists
                        url: "Image  is required",
                    };
                }
                if (!banner?.cta) {
                    bannerErrors.cta = "CTA is required";
                }
                if (!banner?.url) {
                    bannerErrors.url = "CTA Link is required";
                }
                if (banner?.url && !validURL(banner?.url)) {
                    bannerErrors.url = "Invalid link: must start with http:// or https://";
                }
                // Add banner-level errors to the jobOpeningsSection errors array
                if (Object.keys(bannerErrors).length > 0) {
                    errors.jobOpeningsSection.section[index] = bannerErrors;
                }
            });
        }
    }
    if (field?.faq?.status) {
        if (field?.faq?.section?.length > 0) {
            field.faq.section.forEach((banner, index) => {
                const bannerErrors = {};
                // Check for description
                if (!banner.question?.trim()) {
                    bannerErrors.question = "question is required";
                }
                if (!banner.answer?.trim()) {
                    bannerErrors.answer = "answer is required";
                }

                // Add banner-level errors to the topicSection errors array
                if (Object.keys(bannerErrors).length > 0) {
                    errors.faq.section[index] = bannerErrors;
                }
            });


        }
    }
    // **Validate platformAvailability - At least one should be true**
    if (!Object.values(field?.platformAvailability || {}).includes(true)) {
        errors.platformAvailability = "At least one platform must be selected.";
    }

    // **Validate displaySettings - At least one should be true**
    if (!Object.values(field?.displaySettings || {}).includes(true)) {
        errors.displaySettings = "At least one display option must be selected.";
    }
    return {
        errors,
        isValid:
            Object.keys(errors.headerSection.section).length === 0 &&
            Object.keys(errors.brandStorySection.section).length === 0 &&
            Object.keys(errors.customerExperienceSection.section).every(
                (key) => Object.keys(errors.customerExperienceSection.section[key]).length === 0
            ) &&
            Object.keys(errors.testimonialsSection.members).every(
                (key) => Object.keys(errors.testimonialsSection.members[key]).length === 0
            ) &&
            Object.keys(errors.jobOpeningsSection.section).every(
                (key) => Object.keys(errors.jobOpeningsSection.section[key]).length === 0
            ) &&
            Object.keys(errors.faq.section).every(
                (key) => Object.keys(errors.faq.section[key]).length === 0
            ) &&
            Object.keys(errors.metaProperties).length === 0 &&
            errors.platformAvailability === "" &&
            errors.displaySettings === "",
    };
}

// export const validURL = (url) => {
//     const urlPattern = /^(https?:\/\/)([\w.-]+)\.([a-z]{2,6})([/\w .-]*)*\/?$/i;
//     return urlPattern.test(url);
// };

export const validURL = (url) => {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +                    // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,})' + // domain name
      '(\\:\\d+)?' +                           // port
      '(\\/[-a-z\\d%@_.~+&:]*)*' +             // path
      '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' +         // query string
      '(\\#[-a-z\\d_]*)?$',                    // fragment
      'i'
    );
    return !!urlPattern.test(url);
  };
  